import { b64Decode } from "./b64-decode";

export const jwtDecode = (token) =>
  JSON.parse(
    b64Decode(token.split(".")[1].replace("-", "+").replace("_", "/"))
  );
